interface Province {
    name: string,
    code: string,
}

export const Provinces:Province[] = [
    {
		"name": "Baat Dambang",
		"code": "KH-2"
	},
	{
		"name": "Banteay Mean Chey",
		"code": "KH-1"
	},
	{
		"name": "Kampong Chaam",
		"code": "KH-3"
	},
	{
		"name": "Kampong Chhnang",
		"code": "KH-4"
	},
	{
		"name": "Kampong Spueu",
		"code": "KH-5"
	},
	{
		"name": "Kampong Thum",
		"code": "KH-6"
	},
	{
		"name": "Kampot",
		"code": "KH-7"
	},
	{
		"name": "Kandaal",
		"code": "KH-8"
	},
	{
		"name": "Kaoh Kong",
		"code": "KH-9"
	},
	{
		"name": "Kracheh",
		"code": "KH-10"
	},
	{
		"name": "Krong Kaeb",
		"code": "KH-23"
	},
	{
		"name": "Krong Pailin",
		"code": "KH-24"
	},
	{
		"name": "Krong Preah Sihanouk",
		"code": "KH-18"
	},
	{
		"name": "Mondol Kiri",
		"code": "KH-11"
	},
	{
		"name": "Otdar Mean Chey",
		"code": "KH-22"
	},
	{
		"name": "Phnom Penh",
		"code": "KH-12"
	},
	{
		"name": "Pousaat",
		"code": "KH-15"
	},
	{
		"name": "Preah Vihear",
		"code": "KH-13"
	},
	{
		"name": "Prey Veaeng",
		"code": "KH-14"
	},
	{
		"name": "Rotanak Kiri",
		"code": "KH-16"
	},
	{
		"name": "Siem Reab",
		"code": "KH-17"
	},
	{
		"name": "Stueng Traeng",
		"code": "KH-19"
	},
	{
		"name": "Svaay Rieng",
		"code": "KH-20"
	},
	{
		"name": "Taakaev",
		"code": "KH-21"
	}
]